"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SEGMENT_BAR_CLASS = void 0;
exports.deviationScore = deviationScore;
exports.deviationSegmentLabel = deviationSegmentLabel;
exports.deviationSegmentName = deviationSegmentName;
exports.hasResolvedIssues = hasResolvedIssues;
exports.matchesDeviationSegment = matchesDeviationSegment;
exports.tallyDeviationSegments = tallyDeviationSegments;
exports.toDeviationSegment = toDeviationSegment;
var _react = _interopRequireDefault(require("react"));
var _badge = require("@design/ui/badge");
var _utils = require("@design/lib/utils");
var _liveReview = require("@common/schemas/live-review");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var MIN_SEGMENT_HIT_WIDTH_PX = 10;
function Segment(_ref) {
  var width = _ref.width,
    colorClass = _ref.colorClass,
    label = _ref.label,
    isActive = _ref.isActive,
    onClick = _ref.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    type: "button",
    onClick: onClick,
    "aria-pressed": isActive,
    "aria-label": label,
    title: label,
    style: {
      width: "".concat(width, "%"),
      minWidth: "".concat(MIN_SEGMENT_HIT_WIDTH_PX, "px")
    },
    className: (0, _utils.cn)("h-full border-none p-0 rounded-sm transition-all duration-200 ease-out cursor-pointer hover:h-3 hover:-mt-0.5 hover:shadow-[0_2px_4px_rgba(0,0,0,0.1)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2", colorClass, isActive && "h-3 -mt-0.5 shadow-[0_2px_4px_rgba(0,0,0,0.1)]"),
    "data-sentry-component": "Segment",
    "data-sentry-source-file": "DeviationScoreBar.tsx"
  });
}
function isRenderable(i) {
  if (_liveReview.UNREVIEWED_ISSUE_STAGES.has(i.stage)) return false;
  return i.responded || i.conceded || i.match === false || i.stage === "done" || i.stage === "remedy";
}
function hasResolvedIssues(issues) {
  return issues.some(isRenderable);
}
function isUntriggered(i) {
  return i.match === false || i.responded || i.conceded;
}
function deviationSegmentOf(i) {
  if (!isRenderable(i)) return null;
  return isUntriggered(i) ? "compliant" : i.importance;
}
function matchesDeviationSegment(i, segment) {
  return deviationSegmentOf(i) === segment;
}
var SEGMENT_LABELS = {
  compliant: "compliant",
  Low: "low risk",
  Medium: "medium risk",
  High: "high risk",
  Draft: "unscored"
};
var SEGMENT_ORDER = ["compliant", "Low", "Medium", "High", "Draft"];
var LEGEND_ORDER = ["High", "Medium", "Low", "Draft", "compliant"];
function toDeviationSegment(value) {
  var _SEGMENT_ORDER$find;
  return (_SEGMENT_ORDER$find = SEGMENT_ORDER.find(function (segment) {
    return segment === value;
  })) !== null && _SEGMENT_ORDER$find !== void 0 ? _SEGMENT_ORDER$find : null;
}
var SEGMENT_BAR_CLASS = exports.SEGMENT_BAR_CLASS = {
  compliant: "bg-risk-compliant-bar",
  Low: "bg-risk-low-bar",
  Medium: "bg-risk-medium-bar",
  High: "bg-risk-high-bar",
  Draft: "bg-risk-draft-bar"
};
function deviationSegmentName(segment) {
  return SEGMENT_LABELS[segment];
}
function deviationSegmentLabel(segment, count) {
  return "".concat(count, " ").concat(deviationSegmentName(segment), " rule").concat(count === 1 ? "" : "s");
}
function LegendChip(_ref2) {
  var segment = _ref2.segment,
    count = _ref2.count,
    isActive = _ref2.isActive,
    onClick = _ref2.onClick;
  var label = deviationSegmentLabel(segment, count);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_badge.Badge, {
    asChild: true,
    variant: isActive ? "secondary" : "default",
    "data-sentry-element": "Badge",
    "data-sentry-component": "LegendChip",
    "data-sentry-source-file": "DeviationScoreBar.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      type: "button",
      onClick: onClick,
      "aria-pressed": isActive,
      "aria-label": "Show only ".concat(label),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        "aria-hidden": "true",
        className: (0, _utils.cn)("size-2 rounded-full", SEGMENT_BAR_CLASS[segment])
      }), label]
    })
  });
}
function countTallied(tally) {
  return SEGMENT_ORDER.reduce(function (sum, segment) {
    return sum + tally[segment];
  }, 0);
}
function tallyDeviationSegments(issues) {
  var tally = {
    compliant: 0,
    Low: 0,
    Medium: 0,
    High: 0,
    Draft: 0
  };
  var _iterator = _createForOfIteratorHelper(issues),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var issue = _step.value;
      var segment = deviationSegmentOf(issue);
      if (segment) tally[segment] += 1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return tally;
}
function scoreFromTally(tally) {
  var counted = countTallied(tally);
  return counted === 0 ? 0 : 100 - Math.round(tally.compliant / counted * 100);
}
function deviationScore(issues) {
  return scoreFromTally(tallyDeviationSegments(issues));
}
function DeviationScoreBar(_ref3) {
  var issues = _ref3.issues,
    onSegmentClick = _ref3.onSegmentClick,
    _ref3$isCollapsed = _ref3.isCollapsed,
    isCollapsed = _ref3$isCollapsed === void 0 ? false : _ref3$isCollapsed,
    _ref3$activeSegment = _ref3.activeSegment,
    activeSegment = _ref3$activeSegment === void 0 ? null : _ref3$activeSegment,
    _ref3$showLegend = _ref3.showLegend,
    showLegend = _ref3$showLegend === void 0 ? false : _ref3$showLegend;
  var tally = tallyDeviationSegments(issues);
  var total = countTallied(tally);
  var score = scoreFromTally(tally);
  var scoreLabel = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "w-full flex flex-col items-start mb-2",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: (0, _utils.cn)("truncate text-foreground-muted", isCollapsed ? "text-label-sm uppercase tracking-wide" : "text-h4"),
      children: ["Deviation Score: ", score, "%"]
    })
  });
  var segments = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex h-2 gap-[3px] w-full",
    children: SEGMENT_ORDER.filter(function (segment) {
      return tally[segment] > 0;
    }).map(function (segment) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Segment, {
        width: tally[segment] / total * 100,
        colorClass: SEGMENT_BAR_CLASS[segment],
        label: deviationSegmentLabel(segment, tally[segment]),
        isActive: activeSegment === segment,
        onClick: function onClick() {
          return onSegmentClick(segment);
        }
      }, segment);
    })
  });
  var legend = showLegend && !isCollapsed ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "w-full flex flex-wrap items-center gap-1.5 mt-2",
    children: LEGEND_ORDER.filter(function (segment) {
      return tally[segment] > 0;
    }).map(function (segment) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(LegendChip, {
        segment: segment,
        count: tally[segment],
        isActive: activeSegment === segment,
        onClick: function onClick() {
          return onSegmentClick(segment);
        }
      }, segment);
    })
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col items-center flex-1",
    "data-sentry-component": "DeviationScoreBar",
    "data-sentry-source-file": "DeviationScoreBar.tsx",
    children: [scoreLabel, segments, legend]
  });
}
var _default = exports.default = DeviationScoreBar;